// Iter122fd / Iter122fe · Documentazione tecnica scaricabile dal SuperAdmin.
// PDF istituzionali interni: regole multi-account, confronto flussi conversione trial.
import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { BookOpen, ChevronDown, ChevronUp, Download, Loader2, ScrollText, GitCompareArrows, LifeBuoy, ShieldCheck, GraduationCap } from "lucide-react";

const DOCS = [
  {
    key: "multi-account",
    testid: "superadmin-doc-multi-account",
    icon: ScrollText,
    title: "Riepilogo regole multi-account cross-tenant",
    desc: "Modello dati, regole (Iter122bt, 122dg, 122dh), schema visuale e casistiche pratiche per condòmini/fornitori registrati presso più Studi.",
    url: "/superadmin/regole-multi-account/pdf",
    filename: "ginius_regole_multi_account.pdf",
  },
  {
    key: "confronto-flussi",
    testid: "superadmin-doc-confronto-flussi",
    icon: GitCompareArrows,
    title: "Confronto flussi conversione Trial → Paid",
    desc: "Confronto tra il Flusso 1 (tenant self-service · licenza condominio) e il Flusso 2 (SuperAdmin · Converti in studio). Include punti di attrito e linee guida operative.",
    url: "/superadmin/confronto-flussi/pdf",
    filename: "ginius_confronto_flussi_trial.pdf",
  },
  {
    key: "progetto-help-desk",
    testid: "superadmin-doc-progetto-help-desk",
    icon: LifeBuoy,
    title: "Progetto · Help Desk tenant (wizard guidato)",
    desc: "Specifica funzionale del sistema di ticketing interno: wizard 4 step, categorie e SLA, modello dati, endpoint proposti, routing email via Mailjet. Roadmap in 4 fasi.",
    url: "/superadmin/progetto-help-desk/pdf",
    filename: "ginius_progetto_help_desk.pdf",
  },
  {
    key: "progetto-disaster-recovery",
    testid: "superadmin-doc-progetto-disaster-recovery",
    icon: ShieldCheck,
    title: "Progetto · Disaster Recovery dati tenant",
    desc: "Sistema di backup on-demand + automatico programmato, crittografia AES-256, hash SHA-256, procedura di restore assistita SA. Include perimetro dati e nota GDPR.",
    url: "/superadmin/progetto-disaster-recovery/pdf",
    filename: "ginius_progetto_disaster_recovery.pdf",
  },
  {
    key: "tutorial-rac",
    testid: "superadmin-doc-tutorial-rac",
    icon: GraduationCap,
    title: "Tutorial RAC per condòmini",
    desc: "Guida passo-passo per il completamento del Registro di Anagrafe Condominiale: comproprietari (+ Aggiungi), quote 100%, documenti identità + CF, tipologia possesso 1ª/2ª casa. Esempio pratico e FAQ. Allegato automaticamente alle email Campagna RAC e ai modelli \"Pillole di Ginius — RAC\".",
    url: "/superadmin/tutorial-rac/pdf",
    filename: "ginius_tutorial_rac.pdf",
  },
];

export default function SuperAdminDocumentazione() {
  const [open, setOpen] = useState(false);
  const [busyKey, setBusyKey] = useState(null);

  const download = async (doc) => {
    setBusyKey(doc.key);
    try {
      const res = await api.get(doc.url, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = doc.filename;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 15000);
      toast.success("PDF scaricato");
    } catch {
      toast.error("Impossibile scaricare il PDF");
    } finally {
      setBusyKey(null);
    }
  };

  return (
    <Card className="p-4 sm:p-5 border-2" data-testid="superadmin-documentazione">
      <button type="button" data-testid="superadmin-doc-toggle"
        className="w-full flex items-center justify-between gap-2 text-left" onClick={() => setOpen(!open)}>
        <span className="flex items-center gap-2">
          <BookOpen className="w-5 h-5 text-brand" />
          <span className="font-display text-lg font-bold">Documentazione tecnica</span>
          <span className="text-xs text-slate-500 ml-1">({DOCS.length} PDF)</span>
        </span>
        {open ? <ChevronUp className="w-5 h-5 text-slate-400" /> : <ChevronDown className="w-5 h-5 text-slate-400" />}
      </button>
      {open && (
        <div className="mt-4 space-y-3">
          {DOCS.map((doc) => {
            const Icon = doc.icon;
            const busy = busyKey === doc.key;
            return (
              <div key={doc.key} data-testid={doc.testid}
                className="flex flex-wrap items-center justify-between gap-3 p-3 rounded-lg border border-slate-200 bg-slate-50">
                <div className="flex items-start gap-3 min-w-0 flex-1">
                  <div className="shrink-0 rounded-lg bg-brand/10 text-brand p-2"><Icon className="w-6 h-6" /></div>
                  <div className="min-w-0">
                    <div className="font-bold text-slate-800">{doc.title}</div>
                    <div className="text-sm text-slate-500 leading-snug">{doc.desc}</div>
                  </div>
                </div>
                <Button data-testid={`${doc.testid}-download`} disabled={busy} onClick={() => download(doc)}
                  className="h-10 bg-brand hover:bg-brand-dark font-bold shrink-0">
                  {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Download className="w-4 h-4 mr-1.5" />}
                  Scarica PDF
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
